export const CANVAS_META_REQUEST = 'CANVAS_META_REQUEST'
export const CANVAS_META_SUCCESS = 'CANVAS_META_SUCCESS'
export const CANVAS_META_FAILURE = 'CANVAS_META_FAILURE'
